// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"25a228b3","133":"35f591df","488":"a4bda24b","504":"02731e42","770":"c345ce1c","881":"3fad0a1d","923":"75fcb750"}[chunkId] + ".chunk.js";
};